import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { DomainColorSquares } from "./DomainColorSquares";

type RequirementNameWithDomainsProps = {
  name: string;
  requirement?: {
    domains?: any;
    competencies?: any;
  } | null;
  description?: string | null;
  typographyProps?: React.ComponentProps<typeof Typography>;
};

/**
 * Requirement name (and optional description) with domain swatches underneath.
 */
export const RequirementNameWithDomains: FC<
  RequirementNameWithDomainsProps
> = ({ name, requirement, description, typographyProps }) => {
  return (
    <Stack spacing={0.5} alignItems="flex-start" component="span">
      <Typography component="span" variant="body1" {...typographyProps}>
        {name}
      </Typography>
      {description ? (
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      ) : null}
      <DomainColorSquares requirement={requirement} />
    </Stack>
  );
};
